import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LicenceStatusService } from 'src/app/services/licence-status/licence-status.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent {
requestLicence() {
throw new Error('Method not implemented.');
}
  userLicence$: Observable<any>;
  isSuperAdmin: boolean = false;
  user: any = {};
  daysRemaining: number = 0;
  graceDaysRemaining: number = 0;
  progressPercentage: number = 0;
Math: any;

  constructor(private licenceStatusService: LicenceStatusService) {
    this.userLicence$ = this.licenceStatusService.getUserLicence();
  }

  ngOnInit() {
    const userRole = localStorage.getItem("UserROle")!;
    this.isSuperAdmin = userRole === "SUPER_ADMIN";

    this.user = {
      nom: localStorage.getItem("Nom") || '',
      prenom: localStorage.getItem("Prenom") || '',
      email: localStorage.getItem("Email") || '',
      role: userRole,
      inspection: localStorage.getItem("InspectionNom") || ''
    };

    // Calculer les jours restants
    this.userLicence$.subscribe(licence => {
      if (licence && licence.dateExpiration) {
        const today = new Date();
        const expirationDate = new Date(licence.dateExpiration);
        const diffTime = expirationDate.getTime() - today.getTime();
        this.daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        // Calculer le pourcentage de progression
        const startDate = new Date(licence.dateCreation || licence.createdAt);
        const totalDuration = expirationDate.getTime() - startDate.getTime();
        const elapsed = today.getTime() - startDate.getTime();
        this.progressPercentage = Math.min(100, Math.max(0, (elapsed / totalDuration) * 100));

        // Jours de grâce restants
        if (this.daysRemaining < 0 && licence.graceDays) {
          this.graceDaysRemaining = licence.graceDays + this.daysRemaining;
        }
      }
    });
  }

  getStatusClass(status: string): string {
    const classes: any = {
      'ACTIF': 'bg-green-100 text-green-800 border-green-200',
      'EXPIRE': 'bg-red-100 text-red-800 border-red-200',
      'SUSPENDED': 'bg-yellow-100 text-yellow-800 border-yellow-200',
      'DESACTIVE': 'bg-gray-100 text-gray-800 border-gray-200'
    };
    return classes[status] || 'bg-gray-100 text-gray-800';
  }

  getStatusIcon(status: string): string {
    const icons: any = {
      'ACTIF': '✅',
      'EXPIRE': '❌',
      'SUSPENDED': '⏸️',
      'DESACTIVE': '🔴'
    };
    return icons[status] || '📄';
  }

  getStatusText(status: string): string {
    const texts: any = {
      'ACTIF': 'Active',
      'EXPIRE': 'Expirée',
      'SUSPENDED': 'Suspendue',
      'DESACTIVE': 'Désactivée'
    };
    return texts[status] || status;
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'Non définie';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}
